import { render, staticRenderFns } from "./add-candidate-tags.vue?vue&type=template&id=23094446&scoped=true"
import script from "./add-candidate-tags.vue?vue&type=script&lang=ts"
export * from "./add-candidate-tags.vue?vue&type=script&lang=ts"
import style0 from "./add-candidate-tags.vue?vue&type=style&index=0&id=23094446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23094446",
  null
  
)

export default component.exports